function cartDelete() {
    if (!document.querySelector('.js-cart-delete-btn')) return;

    const btns = document.querySelectorAll('.js-cart-delete-btn');

    btns.forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();

            const productDeleteId = btn.dataset.productId;

            modals.openModal(null, '#delete-cart', modal => {
                const formInputDelete = modal.querySelector('.js-form-delete-cart-id');

                formInputDelete.value = productDeleteId;
            })
        })
    })
}
